import { FieldConfig } from '../../models/form-field.model';


export class FormLabelField extends FieldConfig {

  classes?: string[];
  labelStyles?: any;

  constructor(o: FormLabelField) {
    super(o);
    this.type = 'label';
  }


}
